import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {AdxInvoiceErpAdjustment} from '../model/adx-invoice-erp-adjustment';

@Injectable({
  providedIn: 'root'
})
export class AdxInvoiceErpAdjustmentGridService implements GridGetService<AdxInvoiceErpAdjustment> {
  private readonly baseUrl = 'dbov2/adx-invoice-erp-adjustments';
  private readonly http = inject(HttpClient);

  getItems({filters}: GridServiceParams): Observable<GridServiceResponse<AdxInvoiceErpAdjustment>> {
    const params: Record<string, string | number> = {
      tripId: filters?.['tripId'] ?? '',
      adxInvoiceId: filters?.['adxInvoiceId'] ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<AdxInvoiceErpAdjustment[]>(`${this.baseUrl}`, {params: {...params}})
      .pipe(
        map((items) => {
          const adjustments = Array.isArray(items) ? items : [];
          return {
            items: adjustments,
            pagination: {
              hasNextPage: false,
              hasPreviousPage: false,
              pageNumber: 1,
              pageSize: adjustments.length,
              totalItemCount: adjustments.length,
              totalPages: 1,
            },
          };
        }),
        catchError((error: HttpErrorResponse) => {
          throw new Error(error?.message || 'Server error');
        }),
      );
  }
}
